import React, { useContext, useEffect } from 'react';
import { Box, Link, Typography, useTheme } from '@mui/material';
import ReputationPlusImage from '../../assets/images/logos/reputationplus.png';
import LanguageSwitch from '../../components/Header/AvatarMenu/LanguageSwitch/LanguageSwitch';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import { AuthContext } from '../../providers/AuthProvider';

const SuccessPage = () => {
  const theme = useTheme();
  const { t } = useTranslation();
  const location = useLocation();
  const { silentLogout } = useContext(AuthContext);

  const heading = location.state?.heading || t('success_heading');
  const subheading = location.state?.subheading || t('redirection_message');
  const terminateSession = location.state?.terminateSession || false;

  const navigate = useNavigate();

  useEffect(() => {
    const timeout = setTimeout(() => {
      if (terminateSession) {
        silentLogout();
      } else {
        navigate('/login');
      }
    }, 10000);

    return () => clearTimeout(timeout);
  }, [navigate, silentLogout, terminateSession]);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        backgroundColor:
          theme.palette.mode === 'light' ? theme.palette.divider : theme.palette.background.default,
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          maxWidth: '500px',
        }}
      >
        <img
          width="50%"
          src={ReputationPlusImage}
          style={{
            marginLeft: '-20px',
          }}
          alt="Reputativ Logo"
        />
        <Typography
          variant="h4"
          sx={{ fontWeight: '700', mt: theme.spacing(15), color: theme.palette.text.primary }}
        >
          {heading}
        </Typography>
        <Typography
          variant="body1"
          sx={{
            mt: theme.spacing(1),
            mb: theme.spacing(2),
            color: theme.palette.text.secondary,
          }}
        >
          {subheading}
        </Typography>
        <Link
          href="/login"
          variant="body1"
          underline="none"
          sx={{
            color: theme.palette.primary.main,
            mt: theme.spacing(1),
          }}
        >
          {t('skip_redirection_message')}
        </Link>
        <LanguageSwitch sx={{ p: 0, mt: theme.spacing(10) }} />
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Typography
            variant="body2"
            sx={{ mt: theme.spacing(10), color: theme.palette.text.secondary }}
          >
            &#169; {`Reputativ GmbH ${new Date().getFullYear()}`}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default SuccessPage;
